import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardGroupElement,
} from "@easy-email-pro-core/typings";
import React from "react";

import { Group } from "@easy-email-pro-core/components/Elements";
import { Group as SourceElement } from "../../basic/Group";

const defaultData: ElementDefinition<StandardGroupElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {},
    data: {},
  });

export const StandardGroup = createBlock<StandardGroupElement>({
  get name() {
    return t("Group");
  },
  defaultData,
  type: StandardType.STANDARD_GROUP,
  create: (payload) => {
    const defaultData: StandardGroupElement = {
      type: StandardType.STANDARD_GROUP,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.GROUP,
  render(params) {
    const { node } = params;
    return (
      <Group
        idx={params.idx}
        {...node.attributes}
        data={node.data}
        children={params.children || node.children}
      />
    );
  },
});
